import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import type { ComponentProps } from 'react';

type FileTabProps = ComponentProps<'button'> & {
	icon: string;
	active?: boolean;
};

export function FileTab({
	className,
	icon,
	active,
	children,
	...props
}: FileTabProps) {
	return (
		<button
			className={cn(
				'flex shrink-0 items-center gap-1.5 border-border border-e px-3 py-2 font-mono text-xs',
				active
					? 'bg-card text-foreground'
					: 'text-muted-foreground hover:bg-muted/50',
				className,
			)}
			{...props}
		>
			<Iconify icon={icon} className="size-3.5 shrink-0" />
			{children}
		</button>
	);
}
